import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useFetchRpt from "../../Hooks/Mfg/useFetchRpt";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import Spinner from "../../common/Spinner";
import { formatDate } from "../../../utils/basic";
import { useReportActions } from "../../../store/reportStore";

const ViewRpt = () => {

    const viewRptQuery = useFetchRpt();
    const { setMfgViewReportPlates } = useReportActions();
    //had to json parse because API returned data as json string than json array
    const rptData = viewRptQuery?.isSuccess ? JSON.parse(viewRptQuery?.data?.data) : null;

    const dataForTable = (rptData) => rptData?.map(item => {
        const properties = {

            "reportuuid": item["Report UUID"],
            "flu_ver": item["Fluidic Ver"],
            "fam_vic": item.Fam_Vic,
            "fam_hex": item.Fam_Hex,
            "probes": item.Probes,
            "eva": item.Eva,
            "date_created": formatDate(item["Date Created"]),
            "serial_number": item["Serial Number"],
            "id": crypto.randomUUID()

        };
        return properties;
    });

    const data = useMemo(() => {
        return dataForTable(rptData);
    }, [rptData]);

    const cols = [
        {
            field: 'reportuuid',
            headerName: 'Report Id',
            description: 'Report Id',
            // renderCell: (params) => (
            //     // <Link to={`/display/mfg_report/${params.row.reportuuid}/${params.row.flu_ver}`}>{params.value}</Link>
            //     <Link to={`/display/mfg_report/${params.row.reportuuid}/${params.row.flu_ver}`}>{params.value}</Link>
            // ),
            renderCell: (params) => {
                const handleLinkClick = () => {
                    setMfgViewReportPlates([{ "Plate Name": "Fluver", "Plate Value ": params.row.flu_ver }, { "Plate Name": "FamVic", "Plate Value": params.row.fam_vic }, { "Plate Name": "FamHex", "Plate Value": params.row.fam_hex }, { "Plate Name ": "Probes", "Plate Value": params.row.probes }, { "Plate Name": "Eva", "Plate Value": params.row.eva }]);
                };

                return (
                    <Link to={`/display/mfg_report/${params.row.reportuuid}/${params.row.serial_number}`} onClick={handleLinkClick}>
                        {params.value}
                    </Link>
                );
            },
            width: 320
        },
        {
            field: 'serial_number',
            headerName: 'Unit',
            description: 'Unit',
            width: 200
        },
        {
            field: 'date_created',
            type: 'dateTime',
            headerName: 'Date Created',
            description: 'Date Crated',
            width: 200
        },


        {
            field: 'flu_ver',
            headerName: 'Flu Ver',
            description: 'Flu Ver',
            width: 400
        },
        {
            field: 'fam_vic',
            headerName: 'Fam Vic',
            description: 'Fam Vic',
            width: 400
        },
        {
            field: 'fam_hex',
            headerName: 'Fam Hex',
            description: 'Fam Hex',
            width: 400
        },
        {
            field: 'probes',
            headerName: 'Probes',
            description: 'Probes',
            width: 400
        },
        {
            field: 'eva',
            headerName: 'Eva',
            description: 'Eva',
            width: 400
        },


    ];

    return (
        <>
            <h5 className="text-center text-custom-green pb-10">MFG Report Data</h5>

            {rptData?.length > 0 ?
                <div className="oneToolContainer flex h-[80dvh]">
                    <DataGrid columns={cols} rows={data} components={{
                        Toolbar: GridToolbar
                    }}>
                    </DataGrid>
                </div>
                : viewRptQuery?.isFetching ?
                    <Spinner text="Fetching Data... Please wait" /> :
                    viewRptQuery?.isLoadingError ? <p> Sorry could not load processed files...loading error </p> : "No Report files yet.."}

        </>
    )
}

export default ViewRpt;
